export default [
  {
    path: 'M449.28 241.003h288.853c155.094 0 213.462 78.506 204.459 194.005-14.87 190.443-130.005 295.744-282.73 295.744h-77.1c-20.906 0-35.007 13.824-40.703 51.413l-33.067 218.326c-2.155 14.165-9.6 22.506-20.821 23.509H307.05c-17.046 0-23.104-13.035-18.646-41.28L399.02 282.432c4.416-28.075 19.776-41.43 50.282-41.43z',
    fill: '#009DE2',
  },
  {
    path: 'M268.715 0h289.152c81.45 0 178.026 2.645 242.645 59.627 43.157 38.058 65.792 98.709 60.587 163.84-17.792 220.736-149.846 344.426-326.912 344.426H391.573c-24.277 0-40.362 16.064-47.21 59.627l-39.787 253.141c-2.56 16.427-9.707 26.112-22.699 27.264H103.765c-19.754 0-26.773-15.104-21.61-47.85L210.41 48.043C215.53 15.488 233.344 0 268.715 0z',
    fill: '#113984',
  },
  {
    path: 'M348.523 602.005l50.496-319.573c4.416-28.075 19.776-41.43 50.282-41.43h288.832c47.808 0 86.443 7.467 116.715 21.227-29.013 196.48-156.096 305.664-322.539 305.664H389.76c-18.773 0-32.79 9.6-41.216 34.112z',
    fill: '#172C70',
  },
]
